import React from 'react';
import { Button } from '@pwc/pwc-deals-ui';

const PublishButton = ({
  isSaving,
  isValid,
  buttonPosition,
  buttonSize,
  onSaveText = 'Publishing...',
  standbyText = 'Publish',
  dirty = true,
  dataTestId = undefined,
  className = '',
  type = 'submit',
  onClick = () => {},
}) => {
  const isPublishable = !isSaving && isValid && dirty !== false;

  const onClickHandler = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Button
      className={`${className} ${
        buttonSize !== 'button-xs' ? 'button-block' : ''
      } ${buttonSize}`}
      type={type}
      disabled={!isPublishable}
      data-testid={dataTestId || `publish-button-${buttonPosition}`}
      aria-label={standbyText}
      onClick={onClickHandler}
    >
      {isSaving ? onSaveText : standbyText}
    </Button>
  );
};

export default PublishButton;
